import { useContext } from 'react';

import { MatrixDeviceContext } from './MatrixDeviceContext';
import type { MatrixDeviceContextValue } from './types';

const useMatrixDeviceContext = (): MatrixDeviceContextValue => {
  const context = useContext(MatrixDeviceContext);
  if (!context) {
    throw new Error('useMatrixDeviceContext must be used within MatrixDeviceProvider');
  }
  return context;
};

export default useMatrixDeviceContext;
